/*
 Created by qing on 2020/12/29
 Des:
 */

import instances from "../RyHomeConfig/instances";
import {
  CONFIG_TYPE__APPS, CONFIG_TYPE__CONTACT_ME,
  CONFIG_TYPE__DASHBOARD,
  CONFIG_TYPE__QUICK_ENTRY,
  CONFIG_TYPE__TODO, TODO_SHOW_TYPE__NARROW, TODO_SHOW_TYPE__WIDE
} from "./type";

class RyHomeConfig {
  constructor() {

    // 编辑中的chart
    this.editingItem = null

    // 是否初始化
    this.isInit = false
    // 是否修改过
    this.edited = false


    this.userId = null
    this.companyId = null

    this.pageName = ''
    this.customId = ''
    this.matchMember = {
      depart: [], //部门 部门Id
      member: [], //成员 用户Id
      role: [],    //角色 角色Id
      external: [], // 外部联系人 用户Id
      externalTag: [] //外部联系人TagId
    }
    this.configType = "COMPANY" //COMPANY 团队 PERSONAL 个人配置
    this.pageDes = ""
    this.status = 1
    this.sortIndex = 1

    this.children = []

  }

  get configList() {
    return this.children
  }

  set configList(list) {
    this.children.splice(0, this.children.length)
    list.forEach(info => {
      const item = this.createItem(info.configType)
      const config = this.addItem(item)
      if (config.setConf) {
        config.setConf(info)
      } else {
        config.setBase(info)
      }
    })
  }

  get menu() {
    const configTypes = this.children.map(chart => chart.configType)
    console.log('configTypes', configTypes, this.children)
    return [
      {
        label: '工具',
        children: [
          {
            label: '我的待办(竖版)',
            configType: CONFIG_TYPE__TODO,
            ext: {
              showType: TODO_SHOW_TYPE__NARROW
            },
            disabled: configTypes.includes(CONFIG_TYPE__TODO)
          },
          {
            label: '我的待办(横版)',
            configType: CONFIG_TYPE__TODO,
            ext: {
              showType: TODO_SHOW_TYPE__WIDE
            },
            disabled: configTypes.includes(CONFIG_TYPE__TODO)
          },
          {
            label: '快捷入口',
            configType: CONFIG_TYPE__QUICK_ENTRY,
            disabled: false
          },
          {
            label: '常用应用',
            configType: CONFIG_TYPE__APPS,
            disabled: false
          },
          {
            label: '联系我们',
            configType: CONFIG_TYPE__CONTACT_ME,
            disabled: configTypes.includes(CONFIG_TYPE__CONTACT_ME)
          },
        ]
      },
      {
        label: '图表数据',
        children: [
          {
            label: '图表',
            configType: CONFIG_TYPE__DASHBOARD,
            disabled: false
          },
        ]
      }
    ]
  }
}

RyHomeConfig.instancesMap = (() => {
  const obj = {}
  Object.values(instances).forEach(item => {
    obj[item.type] = item
  })
  return obj
})()

RyHomeConfig.init = function (opts = {}) {
  console.log('init', opts)
  const {
    userId = null,
    companyId = null,
    customId = null,
    pageName = '',
    matchMember = {
      depart: [], //部门 部门Id
      member: [], //成员 用户Id
      role: [],    //角色 角色Id
      external: [], // 外部联系人 用户Id
      externalTag: [] //外部联系人TagId
    },
    configType = 'COMPANY',
    pageDes = '',
    sortIndex = 1
  } = opts
  const homeConfig = new RyHomeConfig()
  homeConfig.companyId = companyId
  homeConfig.userId = userId
  homeConfig.customId = customId
  homeConfig.pageName = pageName
  homeConfig.matchMember = matchMember
  homeConfig.configType = configType
  homeConfig.pageDes = pageDes
  homeConfig.sortIndex = sortIndex
  return homeConfig
}
RyHomeConfig.createHomeConfig = function (opts) {
  const homeConfig = RyHomeConfig.init(opts)
  homeConfig.pageName = opts.pageName || ''
  return homeConfig
}
RyHomeConfig.childrenTypes = [
  CONFIG_TYPE__APPS,
  CONFIG_TYPE__DASHBOARD,
  CONFIG_TYPE__QUICK_ENTRY,
  CONFIG_TYPE__TODO
]

// 该根据不同的状态 会被新的函数覆盖 用以让下级图表请求数据请求数据
RyHomeConfig.prototype.chartDataPreviewFun = () => {
}

RyHomeConfig.prototype.getConf = function () {
  return {
    userId: this.userId,
    companyId: this.companyId,
    customId: this.customId,
    pageName: this.pageName,
    matchMember: this.matchMember,
    configType: this.configType,
    pageDes: this.pageDes,
    sortIndex: this.sortIndex,
    status: this.status,
    configList: this.configList
  }
}
RyHomeConfig.prototype.setConf = function (opts) {

  const keys = [
    'userId',
    'companyId',
    'customId',
    'pageName',
    'matchMember',
    'configType',
    'pageDes',
    'sortIndex',
    'status',
    'configList'
  ]

  keys.forEach(key => {
    if (opts[key]) {
      this[key] = opts[key]
    }
  })

  this.edited = false
}


RyHomeConfig.prototype.getConfigList = function () {
  return this.configList.map(chart => {
    if (chart.getConf) {
      return {
        ...chart.getConf(),
        ...chart.getBase()
      }
    } else {
      return {
        ...chart.getBase()
      }
    }
  })
}

// 添加新图表时 计算新图表的 基本位置
RyHomeConfig.prototype.newlyTop = function () {
  if (this.children.length) {
    return Math.max(...this.children.map(item => item.y + item.h))
  } else {
    return 0
  }
}
RyHomeConfig.prototype.newlyLeft = function () {
  let current = null
  this.children.forEach(item => {
    if (current === null) {
      current = item
    } else if (item.y > current.y) {
      current = item
    } else if (item.y === current.y && item.x > current.x) {
      current = item
    }
  })
  return current ? current.x + current.w : 0
}

// 创建图表
RyHomeConfig.prototype.createItem = function (configType) {
  console.log('instancesMap', RyHomeConfig.instancesMap)
  return new RyHomeConfig.instancesMap[configType]()
}
RyHomeConfig.prototype.addItem = function (item) {
  let x = this.newlyLeft()
  let y = this.newlyTop()

  if (x + item.w > 60) {
    x = 0
  }
  item.y = y
  item.x = x
  item.parent = this

  this.children.push(item)
  return item
}

// 获取各个图表的数据
RyHomeConfig.prototype.getConfigValue = function () {

  return Promise.all(
    this.children
      .filter(chart => chart && chart.getValue)
      .map(chart => {
        return chart.getValue()
      })
  )
}
RyHomeConfig.prototype.getConfigMap = function () {
  const map = {}
  this.children.forEach(chart => {
    map[chart.configId] = chart
  })
  return map
}

RyHomeConfig.prototype.copyConfig = function () {

  const dash = RyHomeConfig.init({
    userId: this.userId,
    formId: this.formId,
    companyId: this.companyId,
    appId: this.appId,
    customId: this.customId,
    pageName: this.pageName,
    matchMember: this.matchMember,
    configType: this.configType,
    pageDes: this.pageDes,
    sortIndex: this.sortIndex
  })

  dash.setConf({
    ...this.getConf(),
    configList: this.children.map(item => item.getConf())
  })
  dash.isInit = true
  return dash
}
export default RyHomeConfig
